import type { AntifoulingCoatingFieldProps } from "../models/tech-form-page.models";
import Select from "react-select";
import { twMerge } from "tailwind-merge";

export const AntifoulingCoatingField = ({
  field,
  label,
  value,
  options,
  allowsCustomEntry,
  dataTest,
  error,
  inputBorderClassName,
  isLoading,
  selectStyles,
  onMenuOpen,
  onValueChange,
}: AntifoulingCoatingFieldProps) => {
  const selectedOption =
    options.find((option) => option.value === value || option.label === value) ??
    (value ? { value, label: value } : null);

  return (
    <div className="flex max-w-[220px] flex-col justify-start gap-1">
      <label htmlFor={field} className="text-sm font-bold">
        {label}
      </label>
      {allowsCustomEntry ? (
        <input
          id={field}
          name={field}
          data-test={dataTest}
          type="text"
          value={value}
          onChange={(event) => onValueChange(field, event.target.value)}
          aria-invalid={Boolean(error)}
          placeholder="Enter coating name"
          className={twMerge(
            "h-[50px] w-full rounded-md border pl-2 text-sm focus:outline-none",
            error ? "border-red-600" : inputBorderClassName,
          )}
        />
      ) : (
        <Select
          inputId={field}
          classNamePrefix="rs"
          data-test={dataTest}
          options={options}
          value={selectedOption}
          onChange={(newValue) => onValueChange(field, newValue?.label ?? "")}
          onMenuOpen={onMenuOpen}
          isLoading={isLoading}
          isSearchable
          placeholder="Select an option"
          styles={selectStyles}
        />
      )}
    </div>
  );
};
